import { render, staticRenderFns } from "./ListOfLists.vue?vue&type=template&id=8567cfb0&"
import script from "./ListOfLists.vue?vue&type=script&lang=js&"
export * from "./ListOfLists.vue?vue&type=script&lang=js&"
import style0 from "./ListOfLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports